import React from "react";
import AccordionItem from "./AccordionItem";

const Bar = () => {
  return (
    <section className="lg:px-[5rem] md:px-[2rem] px-[1rem] pb-[4rem]" id="bar">
      <h2 className="text-deepRed italic text-center font-bold volkhov md:text-[46px] sm:text-[35px] text-[25px] md:mt-[100px] mt-[60px] md:mb-[50px] mb-[30px] ">
        Bar & Lounge
      </h2>

      <div className="flex md:flex-row flex-col  justify-center items-center md:gap-[10rem] gap-[2rem]">
        <div className="">
          <p className="text-warning inter lg:text-[18px] text-[16px] lg:leading-[30px] leading-[27px]  max-w-[580px]">
            Elevate your dining experience at StarBites, where our restaurant
            transforms into a vibrant oasis of relaxation and entertainment.
            Welcome to StarBites Bar & Lounge, where every sip is an adventure
            and every moment is a celebration
          </p>

          <div className="lg:mt-[100px]  mt-[40px]">
            <p className="text-lightRed_100 sm:mb-[32px] mb-[15px] volkhov sm:text-[24px] text-[21px] font-bold">
              Menu
            </p>

            <div className="max-w-[700px]">
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"Classic Mojito"}
                price={"₵75.0"}
                content={
                  "Is a refreshing cuban cocktail, a blend of lime, simple syrup, a dash of mint, white rum all topped with club soda"
                }
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"Moscow Mule"}
                price={"₵65.0"}
                content={
                  "A popular cocktail drink made in 1980s during the vodka craze which is a blend of vodka spice ginger beer and lime juice."
                }
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"BOURBON WHISKY 1 LIT"}
                price={"₵980.0 / ₵40.0"}
                content={""}
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"LANATUS FIX"}
                price={"₵90.0"}
                content={
                  "Is a cocktail made to appreciate the beautiful women in Ghana, malibu, apple vodka, melon liquor, pineapple juice, sweet and sour apple syrup"
                }
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"S. O. K"}
                price={"₵100.0"}
                content={
                  "Cocktail best enjoyed in a hot atmosphere made with rum, banana liquor, pineapple juice and lemon juice, green melon liquor"
                }
              />
            </div>
          </div>
          <div className="flex mt-[20px]">
            <a
              href="https://menu.starbitesgh.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-[50px] gap-[5px] lg:px-[20px] px-[15px] py-[9px] cursor-pointer border text-lightRed_100 lg:text-[18px] text-[15px] inter leading-[30px] hover:bg-lightRed_100 hover:text-white transition-all duration-300 font-[600]"
            >
              Explore Menu
            </a>
          </div>
        </div>

        <div>
          <img src="/images/bar-1.png" alt="bar" loading="lazy" />
          <img
            src="/images/bar-2.png"
            alt="bar"
            className="mt-[-150px] xs:ml-[-120px] xs:w-[270px] w-[200px] xs:h-[256px] h-full"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Bar;
